import { useState, useCallback } from 'react';

/**
 * Custom hook for managing boolean toggle state
 * @param {boolean} initialState - Initial toggle state (default: false)
 * @returns {Array} [state, toggle function, set function]
 */
function useToggle(initialState = false) {
  const [state, setState] = useState(initialState);

  const toggle = useCallback(() => {
    setState(prev => !prev);
  }, []);

  return [state, toggle, setState];
}

export default useToggle;
